import { render } from "./SelectCity.vue?vue&type=template&id=f38274c2"
import script from "./SelectCity.vue?vue&type=script&lang=js"
export * from "./SelectCity.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__